import React, { Component } from "react";
import { connect } from "react-redux";
import ComponentHeader from "../common/ComponentHeader";
import CustomTable from "../../utils/commonComponent/CustomAntTable";
import { Col, Image, Row } from "react-bootstrap";
import editPencil from "../../assets/images/edit-icon.png";
import { getAllPlatformDataApi } from "./Api";
import { API_LIMIT, MODULE_ID_MAP, START_PAGE, isModuleExist } from "../../utils/Constant";
import { InformationModal, VerifiedModal } from "../common";
import { toast } from "react-toastify";
import { EVENT_VERIFY, PLATFORM_VERIFY } from "../../utils/urls";
import FilterVefiedDropDown from "../common/FilterVefiedDropDown";
import { deleteAuthCommonApi } from "../content/Api";
import editIcon from '../../assets/images/edit-icon.svg'
import { withRouter } from "../../utils/hoc/withRouter";
import { Tag } from "antd";
import OptionsDropdown from "../../utils/commonComponent/OptionsDropdown";



class Platform extends Component {
  constructor(props) {
    super(props);
    const AccesData = isModuleExist(MODULE_ID_MAP.AutoSharePlatform);

    this.state = {
      access: AccesData,
      search: "",
      pageSize: API_LIMIT,
      currentPage: START_PAGE,
      delete: false,
      deleteData: {},
      editData: "",
      showEdit: false,


      isVerify: false,
      show: false,

      verified: '',
      verifyUrl: ''

    };
  }


  componentDidMount() {
    const { history } = this.props;
    history({
      pathname: this.props.location.pathname,
      search: `?p=${this.state.currentPage || START_PAGE}`,
    });
    this.props.getAllPlatformDataApi(this);

  }

  componentDidUpdate(prevProps, prevState) {
    const prevParams = new URLSearchParams(prevProps.location.search);
    const prevPage = parseInt(prevParams.get("page"), 10) || START_PAGE;
    const prevVerified = prevParams.get("isVerified") || "";
    const prevSize = parseInt(prevParams.get("pageSize"), 10) || API_LIMIT;


    const params = new URLSearchParams(this.props.location.search);
    const page = parseInt(params.get("page"), 10) || START_PAGE;
    const verified = params.get("isVerified") || "";
    const size = parseInt(params.get("pageSize"), 10) || API_LIMIT;

    // const search = params.get("search") || "";

    if (prevPage !== page || prevVerified !== verified || prevParams.get("search") !== params.get("search") || prevSize !== size) {
      this.setState({ currentPage: page }, () => {
        this.props.getAllPlatformDataApi(this);

      });
    }
  }

  getDetailsUser = (data) => {
    this.props.history({ pathname: `/platform/details/${data?.uuid}`, state: { "id": data?.uuid } });
  }

  showEditModal = (rowData = null) => {
    this.props.history({ pathname: `/platform/add-platform`, state: { data: rowData } })
    this.setState({
      showEdit: !this.state.showEdit,
      editData: rowData,
    });
  };

  openCloseDeleteModal = (rowData) => {
    this.setState({
      delete: !this.state.delete,
      deleteData: rowData,
    });
  };

  deleteHandle = async (id) => {
    const res = await deleteAuthCommonApi(`/platform/${id}`);
    // console.log(res)
    if (res.status === 200) {
      this.props.getAllPlatformDataApi(this);
      this.setState({
        delete: !this.state.delete
      });

    } else {
      toast.error("Somthis wrong...")
    }
  }

  render() {
    const { access } = this.state;

    const { platformData, totalPages, currentPage } = this.props.autoShareState;
    // console.log(eventData)
    return (
      <>
        {this.state.delete && (
          <InformationModal
            show={this.state.delete}
            id={this.state.deleteData.uuid}
            title={`Are you sure you want to delete ${this.state.deleteData.platformName}?`}
            handleClose={this.openCloseDeleteModal}
            handleDelete={this.deleteHandle}
          />
        )}
        <VerifiedModal
          name={`'${this.state.editData?.platformName}'`}
          show={this.state.show}
          url={PLATFORM_VERIFY + `/${this.state?.editData?.uuid}`}
          isVerified={this.state.isVerify}
          handleCancel={() => { this.setState({ show: false }) }}
          successRes={() => { this.props.getAllPlatformDataApi(this) }}
        />
        <section>
          <ComponentHeader
            title="Platform"
            breadcrumb={[["Auto Share", "/auto-share"], ["Platform", ""]]}
            isSearch={false}
            ctx={this}
          // primaryBtn={access.createAccess ? "Add Platform" : ""}
          // isSearch={true}
          // isBackArrow={true}
          // isReturn="/contentCollections"
          // handlePrimaryBtn={() => { this.props.history('/platform/add-platform') }}
          />
          <Row>
            <Col sm={2}>
              <FilterVefiedDropDown ctx={this} />
            </Col>
          </Row>
          <div className="commom-table-wrapper">
            <CustomTable
            ctx={this}
              data={platformData?.list}
              columns={[
                {
                  width: 200,
                  title: "Platform Name",
                  dataIndex: "platformName",
                  className: "name",
                  isCell: true,
                  render:(text, rowData, dataKey) => {
                      return rowData.platformName;
                  },
                },
                {
                  width: access.verificationAccess ? 100 : 0,
                  title: "Verified",
                  dataIndex: "isVerified",
                  className: "name",
                  isCell: true,
                  render:(text, rowData, dataKey) => {
                   const color = rowData.isVerified ? 'green' : 'orange';
                    return <div className=" d-flex align-items-center inter-medium">
                      <Tag color={color}>{rowData.isVerified ? "YES" : "NO"}
                        <Image src={editPencil} onClick={() => this.setState({ show: true, isVerify: rowData.isVerified, editData: rowData })} className="edit-pencil-icon" alt="icon" />
                      </Tag>
                    </div>;
                  },
                },

                {
                  width: 200,
                  title: "Code",
                  dataIndex: "code",
                  className: "code",
                  isCell: true,
                  render:(text, rowData, dataKey) => {
                      return rowData.code;
                  },
                },
                {
                  width: 200,
                  title: "Icon Image",
                  dataIndex: "iconImagePath",
                  className: "",
                  isCell: true,
                  render:(text, rowData, dataKey) => {
                      return <Image height={30} width={30} src={rowData?.iconImagePath} className="table-img" alt="Photo" />;
                  },
                },


                {
                  width: 200,
                  title: "Updated By",
                  dataIndex: "updatedBy",
                  className: "name",
                  isCell: true,
                  render:(text, rowData, dataKey) => {
                      return rowData?.updatedBy?.name || 'Na';;
                  },
                },
                {
                  width: 200,
                  title: "Created By",
                  dataIndex: "createdBy",
                  className: "name",
                  isCell: true,
                  render:(text, rowData, dataKey) => {
                      return rowData?.createdBy?.name || 'Na';
                  },
                },
                {

                  width:20,
                  title: "Action",
                  dataIndex: "",
                  className: "",
                  fixed: "right",
                  isCell: true,
                  render:(text, rowData, dataKey) => {
                      return (
                        <>
{/* 
                          {access.updateAccess && (
                            <Image src={editIcon} className="edit-icon" onClick={() => { this.showEditModal(rowData) }} />
                          )} */}
                          {/* {access.deleteAccess && (
                            <Image src={deleteIcon} className="edit-icon" onClick={() => { this.openCloseDeleteModal(rowData) }} />
                          )} */}
                          <OptionsDropdown
                            editHandler={() => { this.showEditModal(rowData) }}
                          />
                        </>
                      );
                  },

                }

              ]}
              
              total={platformData?.length || 0}
              loading={this.state.isLoading}
            />
          </div>
        </section>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  autoShareState: state.AutoShareState,
});
const mapDispatchToProps = {
  getAllPlatformDataApi,
  deleteAuthCommonApi

};
Platform.propTypes = {
  // getPosts: PropTypes.func
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Platform));
